<template>
  <div id="container">
    <vs-popup fullscreen title="Manage Master Stock Codes" :active.sync="showAddMasterCode">
      <manageMasterCodes></manageMasterCodes>
    </vs-popup>
    <vs-button @click="$emit('close')" color="primary" type="border" icon-pack="feather"
      icon="icon-arrow-left"></vs-button>
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/3">
        <vx-card title="Add New Item">
          <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null"
            :finishButtonText="finisButtonLabel" @on-complete="formSubmitted">
            <tab-content title="Company & Stock" class="mb-5">
              <vs-divider> </vs-divider>
              <!-- tab 1 content -->
              <div class="vx-row align-center">
                <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                  <vx-card title="Select Company" class="text-center">
                    <companyRadio v-model="getGr.compId" :defaultValue="getGr.compId" />
                  </vx-card>
                </div>          
                <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                  <vx-card title="Select Stock" class="text-center">
                    <stockRadio v-model="getGr.stock" :defaultValue="getGr.stock" />
                  </vx-card>
                </div>
              </div>
            </tab-content>

            <!-- tab 2 content -->
            <tab-content title="Master Code & Quantity" class="mb-5">
              <div class="vx-row align-center">
                <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                  <div class="vx-row align-center">
                    <vx-card title="Select Stock Code" class="text-center">
                      <template slot="actions">
                        <feather-icon @click="showAddMasterCode = true" icon="PlusIcon"
                          svgClasses="w-6 h-6 text-primary"></feather-icon>
                      </template>

                      <masterCodeField v-model="getGr.masterStockCode" />
                    </vx-card>
                    <vx-card v-if="getGr.masterStockCode" title="Select Sub Stock Code" class="text-center">


                      <subStockCodeField v-model="getGr.subStockCode" :masterStockCode="getGr.masterStockCode.id"
                        :key="getGr.masterStockCode.id" />
                    </vx-card>
                  </div>

                </div>
                <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                  <form>
                    <div class="vx-row">
                      <div class="vx-col w-1/2">
                        <vs-input size="large" v-validate="'max:5|numeric'" label="Quantity Received" name="qtyReceived"
                          v-model="getGr.qtyReceived" class="mt-5 input-center " max="5" />
                        <span class="text-danger text-sm" v-show="errors.has('qtyReceived')">{{
                          errors.first('qtyReceived')
                        }}</span>
                      </div>

                      <div class="vx-col w-1/2">
                        <vs-input size="large" v-validate="'max:5'" label="Unit" name="unit" v-model="getGr.unit"
                          class="mt-5 input-center " max="5" />
                        <span class="text-danger text-sm" v-show="errors.has('unit')">{{
                          errors.first('unit')
                        }}</span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </tab-content>

            <!-- tab 3 content -->
            <tab-content title="Step 3" class="mb-5">
              <suppliersForm></suppliersForm>
            </tab-content>
          </form-wizard>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <vx-card title="Company & Stock" class="mb-5">
          <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info label="Company" :value="getGr.compId" />
            </div>
            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info label="Stock" :value="getGr.stock" />
            </div>
          </div>
        </vx-card>

        <vx-card title="Master Code & Quantity" class="mb-5">
          <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info v-if="getGr.masterStockCode" label="Master Stock Code" :value="getGr.masterStockCode.label" />
              <info v-if="getGr.subStockCode" label="Sub Stock Code" :value="getGr.subStockCode.label" />
            </div>
            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info v-if="getGr.qtyReceived" label="Quantity Received" :value="getGr.qtyReceived" />
              <info v-if="getGr.unit" label="Unit" :value="getGr.unit" />
              <info v-if="getGr.stockBalance" label="Stock Balance" :value="getGr.stockBalance" />
            </div>
            <div v-if="invetoryData" class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info v-if="invetoryData.lineDescription" label="Line Description" :value="invetoryData.lineDescription" />
              <info v-if="invetoryData.sizeDimension" label="Size / Dimension" :value="invetoryData.sizeDimension" />
              <info v-if="invetoryData.thickness" label="Thickness" :value="invetoryData.thickness" />
            </div>
          </div>
        </vx-card>
        <vx-card title="Suppliers & Others">
          <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info v-if="getGr.supplier" label="Supplier" :value="getGr.supplier.label" />
              <info v-if="getGr.supplierDocNumber" label="Supplier Doc No." :value="getGr.supplierDocNumber" />
            </div>
            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info v-if="getGr.others" label="Others" :value="getGr.others.label" />
              <info v-if="getGr.remarks" label="Remarks" :value="getGr.remarks" />
            </div>
          </div>
        </vx-card>

      </div>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import companyRadio from './companyRadio.vue';
import stockRadio from './stockRadio.vue';
import masterCodeField from './masterCodeField.vue';
import subStockCodeField from './subStockCodeField.vue';
import manageMasterCodes from './manageMasterCodes.vue';
import suppliersForm from './suppliersForm.vue';
import info from "@/views/inventory/info.vue";
import { mapGetters } from "vuex";

import { axiosMixin } from "@/mixin/axiosMixin.js";
export default {
  mixins: [axiosMixin],
  components: {
    FormWizard,
    TabContent,
    companyRadio,
    stockRadio,
    info,
    masterCodeField,
    subStockCodeField,
    manageMasterCodes,
    suppliersForm,

  },
  data() {
    return {
      showAddMasterCode: false,
      endPoint: "goodsreceives",
      operation: "add",
      finalValues: {},
      origValue: {},
    }
  },
  methods: {
    startLoading() {
      this.disableSubmitBtn = false;
      this.$vs.loading({
        container: "#container",
        scale: 0.6
      });
    },
    stopLoading() {
      this.disableSubmitBtn = true;
      this.$vs.loading.close("#container > .con-vs-loading");
    },
    formSubmitted() {
      this.origValue = JSON.parse(JSON.stringify(this.getGr));
      this.startLoading();
      this.finalValues = this.getGr;
      this.finalValues.masterStockCode = this.getGr.masterStockCode.id;
      this.finalValues.subStockCode = this.getGr.subStockCode.id;
      // this.finalValues.supplier = this.getGr.supplier.id;
      // this.finalValues.others = this.getGr.others.id;
      this.finalValues.supplier = this.getGr && this.getGr.supplier && this.getGr.supplier.id
        ? this.getGr.supplier.id
        : '';

      this.finalValues.others = this.getGr && this.getGr.others && this.getGr.others.id
        ? this.getGr.others.id
        : '';
      this.finalValues.grNumber = this.$store.state.main.currentGrNumber;
      this.aronPostPut(
        this.endPoint,
        this.$store.state.main.grCurrentItemOperation,
        this.finalValues,
        this.getGr.id
      )
        .then(response => {

          if (this.$store.state.main.grCurrentOperation == "add") {

            this.origValue.grNumber = response.data.grNumber;
            this.$store.state.main.currentGrNumber = response.data.grNumber;
            this.$store.state.main.grCurrentOperation = 'update';
            this.origValue.lineDescription = response.data.lineDescription;
            this.origValue.sizeDimension = response.data.sizeDimension;
            this.origValue.thickness = response.data.thickness;

          } else {
            this.$emit("updateRow", {
              response: response.data,
              view: "view"
            });
            this.origValue.grNumber = response.data.grNumber;
          }

          this.origValue.id = response.data.id;

          this.origValue.status = response.data.status;
          this.origValue.itemNumber = response.data.itemNumber;
          this.origValue.supplier = response.data.supplier;
          this.origValue.others = response.data.others;

          //add to addItemToGrGroup action store updateGrData
          if (this.$store.state.main.grCurrentItemOperation == "add") {
            this.$store.dispatch("main/addItemToGrGroup", this.origValue);
          } else {
            this.$store.dispatch("main/updateGRGroupData", this.origValue);
          }

          //emit close
          this.$emit("close");
          this.stopLoading();
        })
        .catch(error => {
          console.error("error from : update profile_edit. reason:", error);
          this.stopLoading();
        }); // end of aronPostPut
    },
  },
  computed: {
    ...mapGetters({
      getGr: "main/getGr",
      invetoryData: "main/invetoryData"
    }),
    finisButtonLabel() {
      if (this.$store.state.main.grCurrentItemOperation == "add") {
        return "Add Stock";
      } else {
        return "Update Stock";
      }
    },
  }
};
</script>
<style>
.input-center {
  text-align: center;
}

.input-center input {
  text-align: center;
}
</style>
